// Yellow persistent banner shown on the main user-facing app when an
// impersonation token is in use. Visible to the admin only (the real
// user's session is untouched — impersonation tokens live in URL → storage
// for a single tab lifetime).
import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function ImpersonationBanner() {
  const [status, setStatus] = useState(null);
  const [ending, setEnding] = useState(false);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      const tok = localStorage.getItem("tadlo_token");
      if (!tok || sessionStorage.getItem("tadlo_impersonation") !== "1") {
        if (alive) setStatus(null);
        return;
      }
      try {
        const r = await axios.get(`${API_BASE}/auth/impersonation-status`, {
          headers: { Authorization: `Bearer ${tok}` },
        });
        if (alive) setStatus(r.data?.impersonating ? r.data : null);
      } catch {
        if (alive) setStatus(null);
      }
    };
    check();
    const t = setInterval(check, 15000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const endSession = async () => {
    if (!status?.session_id) return;
    setEnding(true);
    try {
      // Best-effort: call end endpoint using admin context is ideal, but
      // the admin's admin-panel token is in a separate memory store. The
      // impersonation token itself can't hit the td-admin endpoint. So we
      // just clear client-side + reload to landing.
      // (Backend auto-expires in 15 min anyway.)
    } finally {
      localStorage.removeItem("tadlo_token");
      localStorage.removeItem("tadlo_user");
      sessionStorage.removeItem("tadlo_impersonation");
      sessionStorage.removeItem("tadlo_impersonation_sid");
      window.location.href = "/login";
    }
  };

  if (!status) return null;

  const exp = status.expires_at ? new Date(status.expires_at).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" }) : "";

  return (
    <div
      data-testid="impersonation-banner"
      style={{
        position: "sticky", top: 0, zIndex: 9999,
        background: "#F6AD55", color: "#1A1A1A",
        padding: "10px 16px", fontSize: 14,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 12, fontFamily: "DM Sans, ui-sans-serif, system-ui, sans-serif",
        borderBottom: "2px solid #C77A18",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <div>
        <strong>⚠ Impersonation Mode</strong>
        {" — Viewing as "}
        <strong>{status.target_user?.name || status.target_user?.email}</strong>
        {" as "}
        <strong>{status.admin_email}</strong>
        {exp && <> · expires {exp} IST</>}
      </div>
      <button
        onClick={endSession}
        disabled={ending}
        style={{
          background: "#1A1A1A", color: "#F6AD55",
          padding: "6px 12px", borderRadius: 6, fontWeight: 600,
          border: "none", cursor: "pointer", fontSize: 13,
        }}
        data-testid="end-impersonation-btn"
      >
        End Session
      </button>
    </div>
  );
}
